import { TagSpecDto } from '@ampsec/platform-client';
import { RuleOption } from 'Core-utils/types/rules.types';
import { TagSpecFormState } from 'Core-utils/types/TagSpecsConfig.types';
import { tryPretty } from 'Core-utils/helpers/ruleBuilderHelpers';

export const emptyTagSpecForm = (): TagSpecFormState => ({
    name: '',
    rid: '',
    description: '',
    configText: '',
    configError: null,
    notify: false,
});

export const formFromTagSpec = (spec: TagSpecDto, allRuleOptions: RuleOption[]): {
    form: TagSpecFormState;
    selectedCid: string;
} => ({
    form: {
        name: spec.name ?? '',
        rid: spec.rid ?? '',
        description: spec.description ?? '',
        configText: tryPretty(spec.config),
        configError: null,
        notify: !!spec.notify,
    },
    selectedCid: allRuleOptions.find((r) => r.value === spec.rid)?.cid ?? '',
});
